import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@admin-core/i18n/translate.pipe';
import { TranslationKey } from '@admin-core/i18n/translations/en';

@Component({
  selector: 'app-ai-marketing-feature-header',
  standalone: true,
  imports: [RouterLink, TranslatePipe],
  templateUrl: './ai-marketing-feature-header.component.html',
  styleUrl: './ai-marketing-feature-header.component.scss'
})
export class AiMarketingFeatureHeaderComponent {
  readonly titleKey = input.required<TranslationKey>();
  readonly subtitleKey = input<TranslationKey | null>(null);
  readonly backLink = input('/admin/ai-marketing');
}
